import lie from 'lie';

/* istanbul ignore next */
var PouchPromise = typeof Promise === 'function' ? Promise : lie;

export default PouchPromise;



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-promise/lib/index.es.js
// module id = 184
// module chunks = 0